import React, { useContext, useEffect, useState } from "react";
import ParamContext from "../contexts/paramContext";
import "../style/global.css";
import noProfile from "../img/defaultProfilePic.png";
import { Tooltip } from "@mui/material";

const Avatar = ({
  title, // optional
  id,
  imgUrl,
  ext,
  onClick,
  update,
  width = "35px",
  height = "35px",
  style,
  nature, // optional
  badge, // optional
}) => {
  const param = useContext(ParamContext);
  const eid = id;
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    const imageUrl = imgUrl + id + "." + ext;
    setImageSrc(imageUrl);
  }, [eid, param.urlimg2, update, ext, id, imgUrl]);

  const renderNatureBadge = () => {
    if (Number.isInteger(nature)) {
      try {
        const natIcon = require(`../img/icons/n${nature}.png`);
        return (
          <img
            key={`nature-${natIcon}-${id}`}
            src={natIcon}
            alt="nature"
            className="nature-badge"
            style={{ overflow: "visible" }}
          />
        );
      } catch (error) {
        return null; // icon not found
      }
    }
    if (badge) {
      try {
        return (
          <div
            className="avatarBadge"
            style={{ overflow: "visible", width: "25px", height: "25px" }}
          >
            {badge}
          </div>
        );
      } catch (error) {
        return null; // icon not found
      }
    }
    return null;
  };

  return (
    <Tooltip
      title={title ?? ""}
      style={{ display: "grid", gridTemplateRows: "auto 0" }}
    >
      <div
        className="userprofile-pic avatar-container"
        onClick={onClick}
        style={{ width, height, ...style }}
      >
        <img
          src={imageSrc}
          className="avatar"
          style={{ width, height }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noProfile;
          }}
        />
      </div>
      {renderNatureBadge()}
    </Tooltip>
  );
};

export default Avatar;
